import React from "react";
import Spinner from "./Spinner";

export interface LoadingStateProps {
  label?: string;
  /** Fill the available vertical space and center. */
  full?: boolean;
  className?: string;
  size?: "sm" | "md" | "lg";
}

/** Centered spinner + label. Replaces scattered `Loading…` text and inline spinners. */
const LoadingState: React.FC<LoadingStateProps> = ({
  label = "Loading…",
  full = false,
  size = "md",
  className = "",
}) => (
  <div
    className={`flex flex-col items-center justify-center gap-3 text-gray-400 ${
      full ? "min-h-[40vh]" : "py-10"
    } ${className}`}
  >
    <Spinner size={size} />
    {label && <p className="text-sm">{label}</p>}
  </div>
);

export default LoadingState;
